module.exports = __webpack_public_path__ + "img/tilda-white.14785575.svg";